<template>
  <div>
    <Card>
      <Row>
        <!-- <Button type="info"
                @click="add">新增</Button> -->
      </Row>
      <Table style="margin-top: 20px;"
             ref="table"
             border
             :loading="loading"
             :columns="columns"
             :data="chain_stores">
        <template slot="manner"
                  slot-scope="{row}">
          <tag color="blue"
               v-if="row.manner==='chain'">直营店</tag>
          <tag color="green"
               v-if="row.manner === 'join'">加盟店</tag>
          <tag color="cyan"
               v-if="row.manner === 'join-online-payment'">线上收款加盟店</tag>
        </template>
      </Table>
      <Modal v-model="modalShow"
             @on-ok="handleSubmit"
             title="新增连锁店">
        <Form ref="chain_store"
              :model="chain_store"
              :label-width="100">
          <Form-item label="连锁店名称"
                     prop="name">
            <Input type="text"
                   v-model="chain_store.name" />
          </Form-item>
          <Form-item label="联系人"
                     prop="user_name">
            <Input type="text"
                   v-model="chain_store.user_name" />
          </Form-item>
          <Form-item label="手机号码"
                     prop="user_mobile">
            <Input type="text"
                   v-model="chain_store.user_mobile" />
          </Form-item>
          <Form-item label="店群类型"
                     prop="manner">
            <Select v-model="chain_store.manner">
              <Option value="chain">连锁店</Option>
              <Option value="join">加盟店</Option>
              <Option value="join-online-payment">加盟店(仅支持线上收款)</Option>
            </Select>
          </Form-item>
          <!-- <Form-item label="密码" prop="mobile">
            初始密码 111111
          </Form-item> -->
        </Form>
      </Modal>
      <Row>
        <Page style="margin-top: 20px;"
              show-total
              :total="meta.total"
              :current="meta.current"
              :page-size="meta.pageSize"
              @on-change="changePage"></Page>
      </Row>
    </Card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
import { commonButtonInTable } from '@/libs/table-render'

export default {
  data () {
    return {
      headers: {
        Authorization: Cookies.get(TOKEN_KEY)
      },
      shopId: localStorage.getItem('SHOPID'),
      query: '',
      modalShow: false,
      formType: '',
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 100,
          align: 'center'
        },
        {
          title: '连锁店名称',
          key: 'name',
          align: 'center'
        },
        {
          title: '手机号码',
          key: 'user_mobile',
          align: 'center'
        },
        {
          title: '联系人',
          key: 'user_name',
          align: 'center'
        },
        {
          title: '副卡支付比率',
          key: 'second_card_rate',
          align: 'center'
        },
        {
          title: '店群类型',
          key: 'manner',
          align: 'center',
          slot: 'manner'
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            const children = []
            // if (this.shopId !== params.row.id.toString()) {
            //   children.push(
            //     commonButtonInTable(
            //       this,
            //       h,
            //       'warning',
            //       '选择',
            //       this.shop_select,
            //       [params.row.id]
            //     )
            //   )
            // } else {
            //   children.push(
            //     commonButtonInTable2(
            //       this,
            //       h,
            //       { type: 'error', disabled: true },
            //       '当前'
            //     )
            //   )
            // }
            children.push(
              commonButtonInTable(
                this,
                h,
                'info',
                '名下店铺',
                this.my_shops,
                [params.row.id]
              )
            )
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.resetQuery()
    this.index()
  },
  computed: {
    ...mapGetters('chain_store', ['chain_store', 'chain_stores', 'chain_stores_all', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('chain_store', ['clear', 'index', 'show', 'create', 'update', 'destroy']),
    ...mapMutations('chain_store', ['changeQuery', 'resetQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    my_shops (id) {
      this.$router.push(`/chain_stores/${id}`)
    },
    shop_select (shop_id) {
      localStorage.setItem('SHOPID', shop_id)
      this.shopId = localStorage.getItem('SHOPID')
    },
    handleSubmit () {
      if (this.formType === 'edit') {
        this.update(this.chain_store)
      } else if (this.formType === 'new') {
        this.create(this.chain_store)
      }
      this.modalShow = false
    }
  }
}
</script>
